import apiClient from '../../../common/services/apiClient';
import { createQueryString } from '../../../common/utils/helpers';

export const apiCallIds = {
  FETCH_ALLOCATION: 'FETCH_ALLOCATION',
  FETCH_ALLOCATION_INVESTMENTS: 'FETCH_ALLOCATION_INVESTMENTS',
  FETCH_ALLOCATIONS: 'FETCH_ALLOCATIONS',
  FETCH_LOAN_ALLOCATIONS: 'FETCH_LOAN_ALLOCATIONS',
  SELL_ALLOCATIONS: 'SELL_ALLOCATIONS'
};

export default {
  fetchAllocation: allocationId => {
    return apiClient.get(`/allocation/${allocationId}`, {
      apiCallId: apiCallIds.FETCH_ALLOCATION,
    });
  },

  fetchAllocationInvestments: (allocationId, options) => {
    return apiClient.get(`/allocation/${allocationId}/investment?${createQueryString(options)}`, {
      apiCallId: apiCallIds.FETCH_ALLOCATION_INVESTMENTS,
    });
  },

  fetchAllocations: options => {
    return apiClient.get(`/allocation?${createQueryString(options)}`, {
      apiCallId: apiCallIds.FETCH_ALLOCATIONS,
    });
  },

  fetchLoanAllocations: loanId => {
    return apiClient.get(`/allocation/loan/${loanId}`, {
      apiCallId: apiCallIds.FETCH_LOAN_ALLOCATIONS,
    });
  },
  sellAllocations: (allocationMap, accountId, buyer, totalAmount, ratio) => {
    return apiClient.post(`/allocation/${accountId}/sell`, {allocationMap, buyer, totalAmount, ratio}, {
      apiCallId: apiCallIds.SELL_ALLOCATIONS
    })
  }
};



// WEBPACK FOOTER //
// ./src/features/allocation-management/api/index.js